var isContentfulAsset = function isContentfulAsset(url) {
  return url.includes('images.ctfassets.net');
};

export default isContentfulAsset;